/* eslint-disable no-useless-escape */
import { methods } from 'http-constants';
import { getUserByToken, setUserToken, removeUserToken } from './auth.crud';
import pluralize from 'pluralize';
import axios from 'axios';
import P from 'bluebird';
import _ from 'lodash';

// Steplix :: TODO :: BEGIN :: Cristian, descomenta esto cuando el microservicio de "signs" este deployado en el API Gateway de AWS
const port = process.env.PORT || 64095;
const env = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
const stage = (env === 'testing' || env === 'development') ? '-test' : (env === 'staging' ? '-stag' : '');
export const baseUrl = `https://api${stage}.dinclin.com`;
export const baseUrlLogin = `https://api${stage}.dinclin.com/auth`;
export const linkUrl = `https://cuotitas-sign${stage}.dinclin.com`;
export const cuotitasUrl = env === 'development' ? `http://localhost:${port}` : `https://cuotitas${stage}.dinclin.com`;

// export const baseUrl = 'https://api-stag.dinclin.com';
// Steplix :: TODO :: END

// Steplix :: TODO :: BEGIN :: Remover estas lineas, cuando se pueda acceder por API Gateway
// export const baseUrl = `http://ec2-54-236-241-73.compute-1.amazonaws.com:64052`;
// export const baseUrl = `https://api-test.dinclin.com/signs`;
// export const baseUrlLogin = `https://api-test.dinclin.com/auth`;
// Steplix :: TODO :: END
export const baseFile = 'http://54.236.241.73:64052/';
// Steplix :: TODO :: BEGIN :: Debería ser seteada a travez del cloudformation
export const baseDownload = 'http://ec2-54-236-241-73.compute-1.amazonaws.com:64052';
// Steplix :: TODO :: END

const defaultOptions = {
    crossDomain: true,
    normalize: true,
    json: true
};

const defaultOptionsFind = {
    pageSize: 10
};
const defaultOptionsGetById = {};
const defaultOptionsGetOne = {
    pageSize: 1,
    page: 1
};

const mapKeys = {
    baseUrl: 'baseURL',
    uri: 'url',
    qs: 'params',
    body: 'data'
};

class Service {
    constructor (name, basePath, options = {}) {
        this.name = pluralize.singular(name);
        this.serviceName = name;
        this.basePath = basePath || `/${name}`;
        this.baseUrl = baseUrl;
        this.baseUrlLogin = baseUrlLogin || `/${name}`;
        this.r = axios.create(options);
        this.r.interceptors.response.use(response => response, e => {
            const origRequest = e.config;
            const has401 = e.response && e.response.data && e.response.data.code === 401 && !origRequest._retry;
            const has400 = e.response && e.response.data && e.response.data.code === 400 && !origRequest._retry && e.response.data.error === 'Bad request. Please set \"Bearer Token\" on authorization parameters';

            if (e.response?.data?.extra?.path === '/tokens/refresh') {
                removeUserToken();
                window.location.replace(`${window.location.origin}/logout`);
                return false;
            }
            if (has401 || has400) {
                origRequest._retry = true;

                // Get logged in user
                const user = getUserByToken();

                if (!user.data) {
                    return Promise.reject(e);
                }

                const token = user.data.token.access_token;
                const refreshToken = user.data.token.refresh_token;

                return this.refreshAccessToken(token, refreshToken)
                    .then(newToken => {
                        setUserToken(newToken.data);
                        const newAccessToken = newToken.data.access_token;
                        this.r.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
                        origRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                        return this.r.request(origRequest);
                    });
            }

            return Promise.reject(e);
        });
    }

    get defaultOptionsFind () {
        return defaultOptionsFind;
    }

    get defaultOptionsGetById () {
        return defaultOptionsGetById;
    }

    get defaultOptionsGetOne () {
        return defaultOptionsGetOne;
    }

    find (options = {}) {
        const data = options.data || options.qs || options.params || (!options.url ? options : {});
        const opts = {
            url: options.url || `${this.basePath}${this.basePath}`,
            params: _.defaultsDeep({}, data, this.defaultOptionsFind)
        };

        return this.get(opts).then(models => {
            if (options && options.normalize === false) {
                return models;
            }
            return this.normalizeAll(models);
        });
    }

    getById (id, options = {}) {
        const data = options.data || options.qs || options.params || (!options.url ? options : {});
        const opts = {
            url: options.url || `${this.basePath}${this.basePath}/${id}`,
            params: _.defaultsDeep({}, data, this.defaultOptionsGetById)
        };

        return this.get(opts).then(model => {
            if (options && options.normalize === false) {
                return model;
            }
            return this.normalize(model);
        });
    }

    getOne (options = {}) {
        const data = options.data || options.qs || options.params || (!options.url ? options : {});
        const opts = {
            url: options.url || `${this.basePath}${this.basePath}`,
            params: _.defaultsDeep({}, data, this.defaultOptionsGetOne)
        };

        return this.get(opts).then(models => {
            const model = (models && models.length && models[0]) || null;

            if (options && options.normalize === false) {
                return model;
            }
            return this.normalize(model);
        });
    }

    request (method, options) {
        return P.bind(this)
            .then(() => {
                return new P((resolve, reject) => {
                    // Get logged in user
                    const user = getUserByToken();
                    if (user && user.data) {
                        const token = user.data.token.access_token;
                        this.r.defaults.headers.common.Authorization = `Bearer ${token}`;
                    }

                    const opts = this.prepareOptions(method, options);

                    if (!opts.json) {
                        this.r.defaults.headers['Content-Type'] = 'multipart/form-data';

                        if (opts.data.file) {
                            const file = new FormData();

                            file.append('filename', opts.data.file.name);
                            file.append('file', opts.data.file.blobFile);
                            opts.data = file;
                        }
                    }

                    return this.r
                        .request(opts)
                        .then(res => resolve(opts.raw ? res : res.data))
                        .catch(error => reject(error));
                });
            });
    }

    refreshAccessToken (accessToken, refreshToken) {
        const opts = {
            url: `${baseUrlLogin}/tokens/refresh`,
            method: 'POST',
            data: {
                accessToken,
                refreshToken
            }
        };

        return this.r
            .request(opts);
    }

    prepareOptions (method, options) {
        if (_.isString(options)) {
            options = {
                url: options,
            };
        }

        if (!_.startsWith(options.url, 'http')) {
            options.url = `${baseUrl}${options.url}`;
        }

        options.method = method || 'get';

        options = _.defaultsDeep({}, _.mapKeys(options, (value, key) => mapKeys[key] || key), defaultOptions);

        return options;
    }

    normalizeAll (models = []) {
        if (_.isNil(models)) {
            return models;
        }

        if (!_.isArray(models)) {
            models = [models];
        }

        return _.map(models, model => this.normalize(model));
    }

    normalize (model) {
        if (_.isNil(model)) {
            return model;
        }

        // Prepare attributes
        if (model.attributes) {
            model.rawAttributes = model.attributes;
            model.attributes = _.keyBy(model.attributes, 'description');
        }

        return model;
    }
}

_.each(_.map(methods, method => method.toLowerCase()), method => {
    Service.prototype[method] = function (options) {
        return this.request(method, options);
    };
});
export default Service;
